import React from "react";
import {Routes, Route} from "react-router-dom";
import MultiStepForm from "./components/MultiStepForm/MultiStepForm";
import "./App.css";

function App() {
  return (
    <div className="App">
       <Routes>
         <Route path="/" element={<MultiStepForm />} />
       </Routes>  
    </div>
  );
}

export default App;

